module.exports = __webpack_public_path__ + "download_app/es-US/images/login_pointer_2x-e24ba757731c2e76f83b855969e5417f.png";


//////////////////
// WEBPACK FOOTER
// ./download_app/es-US/images/login_pointer_2x.png
// module id = iLLC
// module chunks = 14